import axios from "axios";
import Config from "../../utils/Config";
const baseUrl = Config.baseUrl;

class ContactRequests {
  getFormDataHeaders() {
    return {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `Bearer ${localStorage.getItem(
        "txtconnect_ng_user_token"
      )}`,
    };
  }

  getJsonHeaders() {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem(
        "txtconnect_ng_user_token"
      )}`,
    };
  }

  // Todo => Upload Contact File
  async uploadContactFile(contact_file, group_name) {
    try {
      const formData = new FormData();
      formData.append("contact_file", contact_file);
      formData.append("group_name", group_name);
      const response = await axios.post(
        `${baseUrl}api/user/upload/contact/file`,
        formData,
        {
          headers: this.getFormDataHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Get Contact Groups
  async getContactGroups( 
    page = 1,
    limit = 15,
    search = "",
    sortBy = "",
    sortOrder = "desc",
    dateFrom = "",
    dateTo = "",
    ) {
    try {

      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
        ...(sortBy && { sort_by: sortBy }),
        ...(sortOrder && { sort_order: sortOrder }),
        ...(dateFrom && { date_from: dateFrom }),
        ...(dateTo && { date_to: dateTo }),
      });

      const response = await axios.get(`${baseUrl}api/user/contactGroup?${params.toString()}`, {
        headers: this.getJsonHeaders(),
      });
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Add these methods to your ContactRequests class:

// Todo => Get Group Contacts with Pagination
async getGroupContacts(groupSlug, page = 1, limit = 10, search = "") {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
    });

    const response = await axios.get(
      `${baseUrl}api/user/contactGroup/show_contact/${groupSlug}?${params.toString()}`,
      {
        headers: this.getJsonHeaders(),
      }
    );
    
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || error.message,
      status: error.response?.status || 500,
    };
  }
}

// Todo => Display Group Contacts for Exclusion (paginated)
async displayGroupContacts(groupSlug, page = 1, limit = 15, search = "") {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
    });
    const response = await axios.get(
      `${baseUrl}api/user/contactGroup/display_contacts/${groupSlug}?${params.toString()}`,
      { headers: this.getJsonHeaders() }
    );
    return { success: true, data: response.data, status: response.status };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || error.message,
      status: error.response?.status || 500,
    };
  }
}

// Todo => Edit Contact
async editContact(contactId, payload) {
  try {
    const response = await axios.put(
      `${baseUrl}api/user/edit_contact/${contactId}`,
      payload,
      {
        headers: this.getJsonHeaders(),
      }
    );
    
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || error.message,
      status: error.response?.status || 500,
    };
  }
}

// Todo => Delete Single Contact (using the correct endpoint)
async deleteContact(contactId) {
  try {
    const response = await axios.delete(
      `${baseUrl}api/user/delete_contact/${contactId}`,
      {
        headers: this.getJsonHeaders(),
      }
    );
    
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data || error.message,
      status: error.response?.status || 500,
    };
  }
}

  // Todo => Get Single Contact Group by Slug
  async getContactGroupBySlug(contactGroupSlug) {
    try {
      const response = await axios.get(
        `${baseUrl}api/user/contactGroup/show/${contactGroupSlug}`,
        {
          headers: this.getJsonHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Get Contact List
  async getContactList(group_name) {
    try {
      const response = await axios.get(
        `${baseUrl}api/user/contact/list?group_name=${group_name}`,
        {
          headers: this.getJsonHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Delete Contact
  async deleteContact(contact_id) {
    try {
      const response = await axios.delete(
        `${baseUrl}api/user/delete_contact/${contact_id}`,
        {
          headers: this.getJsonHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Delete Contact Group
  async deleteContactGroup(contact_group_slug) {
    try {
      const response = await axios.delete(
        `${baseUrl}api/user/delete/contactGroup/${contact_group_slug}`,
        {
          headers: this.getJsonHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Update Contact (Add to existing group)
  async updateContact(contactData) {
    try {
      const response = await axios.post(
        `${baseUrl}api/user/add/contact`,
        contactData,
        {
          headers: this.getJsonHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  async updateBulkExcelFile(contactData, groupSlug) {
    try {
      const response = await axios.post(
        `${baseUrl}api/user/add/contact`,
        {
          contact_file: contactData,
          contact_group_slug: groupSlug,
        },
        {
          headers: this.getFormDataHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Export Contacts from Group (Email-based)
  async exportContacts(contactGroupSlug) {
    try {
      const response = await axios.get(
        `${baseUrl}api/user/export/contacts/${contactGroupSlug}`,
        {
          headers: this.getJsonHeaders(),
        }
      );

      return {
        success: true,
        data: response.data,
        status: response.status,
        message:
          response.data?.message || "Export request submitted successfully",
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Toggle Contact DND Status
  async toggleContactDnd(contactId, dndStatus, groupSlug) {
    try {
      const response = await axios.put(
        `${baseUrl}api/user/edit_contact/${contactId}`,
        { contact_group_slug: groupSlug, dnd_status: dndStatus },
        { headers: this.getJsonHeaders() }
      );
      return { success: true, data: response.data, status: response.status };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // Todo => Change group name
  async changeGroupName(group_slug, group_name) {
    try {
      const response = await axios.put(
        `${baseUrl}api/user/contactGroup/edit/${group_slug}`,
        {
          group_name,
        },
        {
          headers: this.getJsonHeaders(),
        }
      );
      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}
const contactRequests = new ContactRequests();
export default contactRequests;
